"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _ButtonWithMenu = _interopRequireDefault(require("../ButtonWithMenu"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

/**
 * Vytvoří button určený pro Formulář k libovolnému užití.
 */
var FormButton = /*#__PURE__*/_react.default.forwardRef(function FormButton(_ref, ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color,
      pId = _ref.id,
      menuItems = _ref.menuItems,
      MenuProps = _ref.MenuProps,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'text' : _ref$variant,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "color", "id", "menuItems", "MenuProps", "variant"]);
  return menuItems ? /*#__PURE__*/_react.default.createElement(_ButtonWithMenu.default, (0, _extends2.default)({
    id: pId,
    menuItems: menuItems
  }, MenuProps), function (_ref2) {
    var id = _ref2.id,
        onClick = _ref2.onClick;
    return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
      ref: ref,
      color: color,
      variant: variant
    }, rest, {
      id: id,
      onClick: onClick
    }), children);
  }) : /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    ref: ref,
    color: color,
    variant: variant,
    id: pId
  }, rest), children);
});

FormButton.displayName = 'FormButton';

var _default = (0, _withThemeProps.default)({
  name: 'SxFormButton'
})(FormButton);

exports.default = _default;